.text-align-right{text-align:right!important}
/*# sourceMappingURL=contracts.component-RACD4GR3.css.map */
